import { parseQuizText } from "./quizTextParser";

const metadataLabels = {
    "Quiz title": "title",
    Classroom: "schoolTrack",
    "School classroom": "schoolTrack",
    Subject: "category",
    Category: "category",
    Description: "description",
    Difficulty: "difficulty",
    Status: "status"
};

export function exportQuizText(quiz) {
    const lines = [
        `Quiz title: ${quiz.title}`,
        `School classroom: ${quiz.schoolTrack}`,
        `Subject: ${quiz.category}`,
        `Description: ${quiz.description.replace(/\r?\n/g, " ")}`,
        `Difficulty: ${quiz.difficulty}`,
        `Status: ${quiz.status}`,
        ""
    ];

    quiz.questions.forEach((question, questionIndex) => {
        lines.push(`${questionIndex + 1}. ${question.question}`);
        question.options.forEach((option, optionIndex) => {
            lines.push(`${String.fromCharCode(65 + optionIndex)}) ${option}`);
        });
        lines.push("");
    });

    lines.push("Answer Key:");
    quiz.questions.forEach((question, questionIndex) => {
        if (Number.isInteger(question.correctIndex)) {
            lines.push(
                `${questionIndex + 1}. ${String.fromCharCode(65 + question.correctIndex)}`
            );
        }
    });

    return lines.join("\n");
}

export function importQuizText(rawText) {
    const metadata = {};
    const questionText = rawText
        .replace(/^\uFEFF/, "")
        .split(/\r?\n/)
        .filter((line) => {
            const match = line.match(/^(Quiz title|Classroom|School classroom|Subject|Category|Description|Difficulty|Status):\s*(.*)$/i);
            if (!match) {
                return true;
            }
            const label = Object.keys(metadataLabels).find(
                (key) => key.toLowerCase() === match[1].toLowerCase()
            );
            metadata[metadataLabels[label]] = match[2].trim();
            return false;
        })
        .join("\n");

    return {
        ...parseQuizText(questionText),
        metadata
    };
}
